import { compareFWVersions } from './firmware_compare_helpers';

export const FW_1_7_5_VERSION = '1.7.5';

/**
 * Check if a device has secure provisioning (FW 1.7.5+).
 * Use in device settings context where device info is available.
 * For BLE inclusion flow, use simpler Gen2+ check since FW version
 * is not available until after connection.
 */
export const hasSecureProvisioning = (device: { provision?: string; ver?: string } | null): boolean => {
	if (!device) return false;
	return !!device.provision || compareFWVersions(device.ver || '', '>=', FW_1_7_5_VERSION);
};
